module.exports = __webpack_public_path__ + "img/about-shape-3.079aba11.png";